/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:53:19
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "ডিভাইচ মডেল বাছনি কৰক",
    name2: "ত্ৰুটি বিৱৰণ:",
    name3: "সেৱা দোকান বাছনি কৰিবলৈ টেপ কৰক",
    name4: "সেৱা দোকান:",
    name5: "সংৰক্ষণৰ সময়:",
    name6: "অনুগ্ৰহ কৰি আপোনাৰ ডিভাইজৰ সমস্যাৰ বিৰ্ণনা কৰক!",
    name7: "আগমনৰ সময় বাছনি কৰিবলৈ টেপ কৰক",
    name8: "অনুগ্ৰহ কৰি আপোনাৰ শুদ্ধ যোগাযোগৰ বিৱৰণ লিখক যাতে আমি আপোনাৰ সৈতে যোগাযোগ কৰিব পাৰোঁ",
    name9: "উপলব্ধ সংৰক্ষণ সময় এনেধৰণ",
    name10: "অনুগ্ৰহ কৰি আপোনাৰ ফোন নম্বৰ প্ৰবিষ্ট কৰক",
    name11: "মূল্য",
    name12: "ব্যক্তিগত তথ্য:",
    name13: "অনুগ্ৰহ কৰি আপোনাৰ নাম লিখক",
    name14: "দাখিল কৰা",
    name15: "বাতিল কৰক",
    name16: "হ'ব",
  },
  shops: {
    name1: "আপুনি বাছনি কৰা ব্ৰেণ্ডৰ ওপৰত ভিত্তি কৰি, নিম্নলিখিত দোকানবোৰে আপোনাক সেৱা কৰিব পাৰে!",
    name2: "অধিক খুচুৰা দোকানত সোনকালে আহি আছে! আমাৰ সৈতে থাকক!",
  },
  price: {
    name1: "ব্ৰেণ্ড:",
    name2: "মডেল",
    name3: "আইটেম",
    name4: "মূল্য",
    name5: "বন্ধুত্বপূৰ্ণ স্মৰণ:",
    name6: "এই মূল্যবোৰ কেৱল উল্লেখ কৰিবলৈহে,  আৰু প্ৰকৃত মূল্য ডিভাইচৰ অৱস্থা অনুসৰি হ\'ব।",
    name7: "যদি কোনো বিশেষ চিহ্ন নাই, মূল্যৰ পৰিমাণ স্থানীয় মুদ্ৰাৰ একক অনুসৰি হ\'ব।",
    name8: "ক্ষমাকৰিব! বৰ্তমান স্থানত কোনো মূল্যৰ তথ্য উপলব্ধ নহয়।",
    name11:"শ্ৰমিকৰ ব্যয়",
    name12:"মুঠ মূল্য",
    name13: "5. যদি শ্ৰমিকৰ খৰচ \"/\" হয়, ইয়াৰ অৰ্থ হৈছে শ্ৰমিকৰ খৰচ দোকানখনৰ সৈতে আলোচনা কৰিব লাগিব।",
    item_main_board: "মেইনব\\'ৰ্ড",
    item_screen_frame: "পর্দা (ফ্ৰেম)",
    item_screen_screen_frame: "দ্বিতীয় পৰ্দা (ফ্ৰেম)",
    item_touch_screen: "টাচ্চ স্ক্ৰীণ",
    item_camera: "কেমেৰা",
    item_fixed_focus_camera: "ফিক্সড ফ\\'কাচ কেমেৰা ",
    item_auto_focus_camera: "অটো ফ\\'কাচ কেমেৰা ",
    item_screen: "পর্দা",
    item_secondary_screen: "দ্বিতীয় পৰ্দা",
    item_fingerprint_module: "আঙুলিৰ ছাপৰ মডিউল",
    item_speaker: "স্পিকাৰ",
    item_receiver: "ৰিচিভাৰ",
    item_small_board: "সৰু বৰ্ড",
    item_battery_cover: "বেটাৰী কভাৰ",
    item_battery: "বেটাৰী",
    item_charger: "চাৰ্জাৰ",
    item_usb_cable: "ইউএছবি কেবল",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "কোনো তথ্য নাই",
    name2: "সেৱা প্ৰদানকাৰী:",
    name3: "সেৱা ব্ৰেণ্ড:",
    name4: "টেলিফোন:",
    name5: "অৰ্ডাৰৰ পৰিমাণ:",
    name6: "সেৱা ৰেটিং",
    name7: "সেৱা পৰিৱেশ:",
    name8: "সেৱা মনোভাৱ:",
    name9: "সেৱা দক্ষতা:",
    name10: "সেৱাৰ মানদণ্ড:",
    name11: "গ্ৰাহক মূল্যায়ণ",
    name12:"লৈ",
    name13:"বন্ধ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare খোলক",
    name1: "অনুগ্ৰহ কৰি সংৰক্ষণ তথ্যৰ স্ক্ৰীণশ্বোট লওক আৰু ইয়াক অগ্ৰাধিকাৰ সেৱা লাভ কৰিবলৈ এক ৰচিদ হিচাপে ছেভ কৰক।",
    name2: "সফলতাৰে দাখিল কৰা হৈছে",
    name3: "1. ক্লিন আপ ডাটা",
    name4: "অনুগ্ৰহ কৰি আপোনাৰ ফোনত আগতীয়াকৈ গুৰুত্বপূৰ্ণ ব্যক্তিগত তথ্যৰ বেকআপ লওক",
    name5: "2. পাৱাৰ অন পাছৱৰ্ড সক্ৰিয় কৰক",
    name6: "ছাৰ্ভিচ ষ্টোৰলৈ যোৱাৰ আগতে, অনুগ্ৰহ কৰি :",
    name7: "সেৱা দোকান:",
    name8: "সংৰক্ষণৰ সময়:",
    name9: "ত্ৰুটি বিৱৰণ:",
    name10: "ডিভাইচ মডেল:",
    name11: "অৰ্ডাৰ নম্বৰ:",
    name12: "অৰ্ডাৰ তথ্য",
  },
  title: {  
    name1: "এই দেশবোৰক সমৰ্থন কৰক:",
    name2: "মডেল বাছনি কৰক",
    name3: "সংৰক্ষণ",
    name4: "সেৱা দোকানৰ বিৱৰণ",
    name5: "সেৱা দোকান বাছনি কৰক",
  },
  error: { 
    name1: "ডাটা নাই। অনুগ্ৰহ কৰি আপোনাৰ মেৰামতিৰ তথ্য পৰীক্ষা কৰক",
    name2: "অধিক সহায়ৰ প্ৰয়োজন? অনুগ্ৰহ কৰি আমাৰ সৈতে যোগাযোগ কৰক।",
    name3: "ক্ষমা কৰিব, বৰ্তমান স্থানত কোনো Carlcare চেন্টাৰ নাই।",
    name4: "অনুগ্ৰহ কৰি প্ৰথমে এটা ছাৰ্ভিচ চেন্টাৰ পচন্দ কৰক",
    name5: "ব্যৰ্থ",
    name6: "অনুগ্ৰহ কৰি প্ৰথমে এটা ডিভাইচ মডেল পচন্দ কৰক",
    name7: "বিৱৰণ",
    name8: "অনুগ্ৰহ কৰি আপোনাৰ আৱশ্যকতাৰ বিৰৰণ দিয়ক ",
    name9: "",
  },
  add1:{
    "name0": "as",
    "name1": "আপোনাৰ অৰ্ডাৰ নিশ্চিত কৰা হৈছে। আমি আপোনাৰ আগমনলৈ আশা কৰি থাকিম।",
    "name2": "চহৰ নিৰ্বাচন কৰক",
    "name3": "অনুগ্ৰহ কৰি %1$s সংখ্যাৰ ফ\\'ন নম্বৰ ইনপুট কৰক।",
    "name4": "সপ্তাহৰ দিনৰ ঘন্টা",
    "name5": "সোমবাৰ",
    "name6": "মংগলবাৰ",
    "name7": "বুধবাৰ",
    "name8": "বৃহস্পতিবাৰ",
    "name9": "শুক্ৰবাৰ",
    "name10": "শনিবাৰ",
    "name11": "দেওবাৰ",
    "name12": "দেশ প্ৰবিষ্ট আৰু সন্ধান কৰক"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "অন্যান্য",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"পুনঃনিৰ্দেশিত কৰিবলৈ টেপ কৰক",
    name3:"Carlcare এপটো খোলক যাতে আপুনি অৰ্ডাৰটো মূল্যাংকন কৰিব পাৰে",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"সেৱা নিৰ্বাচন কৰক",
    name7:"বিনামূলীয়া পৰিষ্কাৰকৰণ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "অশুদ্ধ তথ্য",
    "cancelReason1": "সময়ত উপস্থিত হ\\'ব নোৱাৰে",
    "cancelReason2": "ডুপ্লিকেট অৰ্ডাৰ/মোৰ অৰ্ডাৰ নহয়",
    "cancelReason3": "বিফলতা পুনৰাই নঘটে",
    "cancelReason4": "কেৱল পৰীক্ষণ/অনুসন্ধান/ঘটনা/…ৰ বাবে",
    "cancelReason5": "উচ্চ মূল্য",
    "cancelReason6": "সামগ্ৰী নাটনি ",
    "cancelReason7": "কোনো পৃথকীকৃত সেৱা নাই",
    "cancelReason8": "ষ্টোৰখন বৰ দুৰ ",
    "cancelReason9": "ষ্টোৰখন বন্ধ আছে ",
    "cancelReason10": "বেয়া সেৱাৰ মনোভাৱ",
    "cancelReason11": "আন ব্ৰেণ্ডসমূহৰ বাবে পুনঃস্থাপন/মেৰামতি",
    "cancelReason12": "ষ্ট\\'ৰ বিচাৰি পোৱা নাই",
    "cancelReason13": "অন্যান্য",
    "cancelOrder": "অৰ্ডাৰ বাতিল কৰক",
    "reason_dialog_title": "অনুগ্ৰহ কৰি বাতিল কৰাৰ কাৰণ আমাক কওক ",
    "Cancel": "বাতিল কৰক",
    "OK": "হ\\'ব",
    "name1": "Enter verification code",
    "name2": "প্ৰমাণিকৰণ কোড অবৈধ",
    "repair_reservation_detail_canceled": "এই অৰ্ডাৰটো বাতিল কৰা হৈছে!",
    "purchase_cancel_dialog_content": "আপুনি অর্ডাৰ বাতিল কৰিবলৈ নিশ্চিত কৰেনে?",
    "yes": "হয়",
    "no": "নহয়"
}
};
